import { RolesSection } from "@/components/role-editor";
import { Page } from "@/components/ui/page";

/**
 * Roles and permissions, which used to be the ninth section of the
 * Configuration rail and is now a place of its own.
 *
 * The screen is the same one — `RolesSection` draws both the list and the
 * editor it swaps itself for — so the move is the frame around it and the way
 * in, not the work. The way in is the account menu at the foot of the sidebar,
 * beside the profile and the password, rather than a row in the menu proper.
 */
function RolesPage() {
  return (
    <Page>
      <RolesSection />
    </Page>
  );
}

export default RolesPage;
